import { render } from "./ShowDisbursements.vue?vue&type=template&id=fd973e34"
import script from "./ShowDisbursements.vue?vue&type=script&lang=js"
export * from "./ShowDisbursements.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__